module.exports = {"us":"Americas","eu":"Europe","cn":"China","tw":"Taiwan","kr":"Korea","world":"World"};